const RESET_FORM = "RESET_FORM";
const SET_DIRTY = "SET_DIRTY";
const SET_VALUE = "SET_VALUE";
const INIT_FORM = "INIT_FORM";

export function setValue(value) {
  return {
    type: SET_VALUE,
    value,
  };
}

export function setDirty(isDirty) {
  return {
    type: SET_DIRTY,
    isDirty,
  };
}

export function initForm(value) {
  return {
    type: INIT_FORM,
    value,
  };
}

export function resetForm() {
  return {
    type: RESET_FORM,
  };
}

const INIT_STATE = {
  isDirty: false,
  customForm: [],
};

export default function TimesheetTableDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_VALUE:
      newState.isDirty = true;
      newState.customForm = action.value;
      break;
    case SET_DIRTY:
      newState.isDirty = action.isDirty;
      break;
    case INIT_FORM:
      newState.customForm.push(action.value);
      break;
    case RESET_FORM:
      newState.customForm = [];
      newState.isDirty = false;
      break;
  }
  return newState;
}

/* [
  {
    month: 202205,
    day: 1,
    ore: 8,
    projectTaskId: 111,
    projectTaskMainId: 111, // se è MAIN o CANCEL sono uguali adjust cambia il projectTaskId
    type:MAIN // oppure CANCEL ADJUST
  }
]

[
  {
    projectTaskId: 111,
    month: 202205,
    type:CANCEL,
    projectTaskMainId: 111,
    hours:{
      1: 8,
      2: 8
    } 
  }
] */
